export default "__VITE_ASSET__7ed22381__"